import apiUrls from '../urls'

export default function (api) {
	return {
		getGifts(ctx) {
			return api.get(`${apiUrls.GIFTS}?page=${ctx.current_page}`)
		},
		activateGift(id) {
			return api.post(apiUrls.ACTIVATE_GIFT, { order_id: id })
		},
	}
}
